module.exports = __webpack_public_path__ + "img/geology-saturn.aa61a7dc.png";